import React, {useEffect, useState} from "react";
import {useSearchParams} from "react-router-dom";
import {captureStripePayment} from "../api/apiClient";
import PaymentConfirmation from "../components/PaymentConfirmation";
import {trackEvent} from "../utils/fbPixel";

const StripePaymentConfirmationPage = () => {
    const [searchParams] = useSearchParams();
    const [paymentStatus, setPaymentStatus] = useState(null); // null, "success", "event_full", "general_error"

    useEffect(() => {
        const sessionId = searchParams.get("session_id");

        if (sessionId) {
            const abortController = new AbortController();

            // generate microtime
            const microtime = new Date().getTime();

            captureStripePayment(sessionId, microtime, abortController.signal)
                .then((data) => {
                    if (data === "success") {
                        setPaymentStatus("success");
                        // Track successful purchase
                        trackEvent('Purchase', {currency: 'EUR'});
                    }
                    else if (data === "event_is_full") {
                        setPaymentStatus("event_full");
                    }
                    else {
                        setPaymentStatus("general_error");
                    }
                })
                .catch((error) => {
                    console.error(error);
                    setPaymentStatus("general_error");
                });
        }
    }, [searchParams]);



    return <PaymentConfirmation paymentStatus={paymentStatus} paymentProvider="Stripe" />;
};

export default StripePaymentConfirmationPage;
